import { createLogger, type Logger } from '@almadar/logger';
import type { IntegrationLogger, LogMeta } from '../types';

/**
 * Console-based logger implementation.
 *
 * Routes through `@almadar/logger`'s shared gate so namespace filtering
 * (`ALMADAR_DEBUG`, `globalThis.__ALMADAR_DEBUG__`) and the production
 * level default (WARN+) apply uniformly with the rest of `@almadar/*`.
 *
 * The constructor's `level` argument is retained for backwards
 * compatibility but is now a no-op — the active level is owned by the
 * shared logger (compile-time + env). To filter integration logs at
 * runtime, set `globalThis.__ALMADAR_DEBUG__ = 'almadar:integrations:*'`.
 */
export class ConsoleLogger implements IntegrationLogger {
  private readonly log: Logger;

  constructor(_level: 'debug' | 'info' | 'warn' | 'error' = 'info') {
    void _level;
    this.log = createLogger('almadar:integrations');
  }

  debug(message: string, meta?: LogMeta): void {
    this.log.debug(message, meta);
  }
  info(message: string, meta?: LogMeta): void {
    this.log.info(message, meta);
  }
  warn(message: string, meta?: LogMeta): void {
    this.log.warn(message, meta);
  }
  error(message: string, meta?: LogMeta): void {
    this.log.error(message, meta);
  }
}
